import { Save, CheckCircle2 } from "lucide-react";

export default function SaveActions({ busy, savedEntryId, onSavePending, onApprove }) {
  return (
    <div className="grid grid-cols-2 gap-3 sticky bottom-20 sm:bottom-24 pt-1 z-20">
      <button
        type="button"
        data-testid="rv-save-pending"
        disabled={busy}
        onClick={onSavePending}
        className="h-16 rounded-xl bi-ghost-btn flex items-center justify-center gap-2 backdrop-blur bg-[#1F1F1F]/80 disabled:opacity-60 font-heading text-sm uppercase tracking-wide"
      >
        <Save className="w-4 h-4" /> {savedEntryId ? "Update Queue" : "Save to Queue"}
      </button>
      <button
        type="button"
        data-testid="rv-save-approve"
        disabled={busy}
        onClick={onApprove}
        className="h-16 rounded-xl bi-accent-btn bi-shimmer flex items-center justify-center gap-1.5 disabled:opacity-60 font-heading text-sm uppercase tracking-wide"
      >
        <CheckCircle2 className="w-4 h-4 shrink-0" />
        <span className="whitespace-nowrap">Approve &amp; Save</span>
      </button>
    </div>
  );
}
